
<template>
  <div class="local-main-page" >
    <ListView ref="list-view" :complex-list="mainData" :option="listOption" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ListView from '@/components/data/ListView'
import { reactiveLayout } from '@/plugin'
import mainData from './mainData'

export default defineComponent({
  name: 'ServiceProvider',
  components: {
    ListView
  },
  data() {
    return {
      mainData,
      listOption: {
        table: {
          optionProps: {
            bordered: true,
            scroll: {
              x: this.getWidth()
            }
          }
        },
        search: {
          // layout: 'horizontal'
        },
        searchMenu: [
          {
            prop: 'setSearch',
            name: '查询',
            type: 'primary'
          },
          {
            prop: 'resetSearch',
            name: '重置',
            type: 'default'
          },
          {
            prop: 'build',
            name: '新增',
            type: 'primary'
          },
          {
            prop: 'delete',
            name: '删除',
            type: 'danger',
            disabled() {
              return mainData.$module.choice!.getId().length === 0
            }
          }
        ],
        menu: {
          list: [
            {
              prop: 'change',
              name: '编辑'
            }
          ]
        }
      }
    }
  },
  computed: {
    width() {
      return this.getWidth()
    }
  },
  mounted() {
    this.mainData.$reloadData({})
  },
  methods: {
    getWidth() {
      return reactiveLayout.data.main.width - 16 * 2
    }
  }
})
</script>
